import { Component, computed, inject, input, signal, viewChild } from '@angular/core';
import { BuildingEquipmentDetailDto, RepairTaskService } from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';
import { RepairTaskDispatchService } from '@services/repair-task-dispatch.service';
import {
  BuildingRepairTaskOverviewComponent,
} from '../../building-detail-page/building-repair-task-overview/building-repair-task-overview.component';

@Component({
  standalone: false,
  selector: 'wr-building-equipment-repair-tasks-tab',
  templateUrl: './building-equipment-repair-tasks-tab.component.html',
  styleUrl: './building-equipment-repair-tasks-tab.component.scss',
})
export class BuildingEquipmentRepairTasksTabComponent {
  private readonly repairTaskService = inject(RepairTaskService);
  private readonly dispatchService = inject(RepairTaskDispatchService);
  private readonly currentUserService = inject(CurrentUserService);

  readonly buildingEquipment = input.required<BuildingEquipmentDetailDto>();
  private readonly overview = viewChild(BuildingRepairTaskOverviewComponent);

  readonly canCreate = this.currentUserService.hasPrivilege('canEditRepairTasks');
  readonly creating = signal(false);
  readonly buildingId = computed(() => this.buildingEquipment().building.id);

  async create(): Promise<void> {
    const equipment = this.buildingEquipment();
    this.creating.set(true);
    try {
      const created = await this.dispatchService.createAndSend({
        buildingId: equipment.building.id,
        buildingEquipmentId: equipment.id,
        title: `Reparatur ${equipment.equipment.name}`,
        description: `TGA: ${equipment.equipment.name}\nHausnummer: ${equipment.buildingSection.sectionText}`,
        loadContractorOptions: () => this.repairTaskService.findEquipmentContractorOptions(equipment.id),
        emptyContractorMessage: 'Dem Gebäude ist für die Gewerke dieser TGA kein Dienstleister zugewiesen.',
      });
      if (created) {
        this.overview()?.refresh();
      }
    } finally {
      this.creating.set(false);
    }
  }
}
